import { brandBlogRecommendations } from '../../../shared/brand-blog/recommendations';

export const stratdotBlogRecommendations = brandBlogRecommendations
  .filter((article) => article.publisher === '策點文化')
  .sort((left, right) => right.publishDate.localeCompare(left.publishDate));
